import styled, { css, keyframes } from "styled-components";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

export const Container = styled.div`
  display: flex;
  gap: 7px;
  padding: ${(p) => (p.$offHorizontalPadding ? 0 : "0 16px 0px 16px")};
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: ${(p) => (p.$minHeight ? "32px" : "unset")};

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-top: 2px;
`;

export const CloseIconWrapper = styled.div`
  height: 100%;
  width: 44px;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const CloseIcon = styled(CloseSvg)``;

export const SearchFilter = styled.div`
  display: flex;
  height: 32px;
  padding: 0 8px 0 11px;
  align-items: center;
  border-radius: 100px;

  border: 1px solid #345884;
  background: #112238;

  cursor: ${(props) => (props.$expanded ? "default" : "pointer")};

  width: ${(props) => (props.$expanded ? "230px" : "44px")};
  transition:
    width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    background 0.3s ease,
    opacity 0.3s ease;

  @media (max-width: 768px) {
    min-width: ${(props) => (props.$expanded ? "230px" : "44px")};
    transition:
      min-width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
      background 0.3s ease,
      opacity 0.3s ease;
  }

  @media (max-width: 480px) {
    width: ${(props) => (props.$expanded ? "230px" : "44px")};
  }
  position: relative;

  svg {
    min-height: 26px;
    min-width: 26px;
    max-height: 26px;
    max-width: 26px;
  }
  div {
    z-index: 10;
    left: ${(props) => (!props.$expanded ? "-2.5px" : "-2.5px")};
  }
`;

export const StyledInput = styled.input`
  background-color: blue;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.07px;
  padding-left: 30px;
  z-index: 2;

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;
export const Relative = styled.div`
  position: relative;
  margin-top: 2px;
`;

export const InfoContainer = styled.div`
  display: flex;
  width: 329px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  z-index: 25; /* visok z-index da bude iznad svega */

  border-radius: 16px;
  border: 1px solid #142743;
  background:
    radial-gradient(
      115.96% 54.63% at 36.53% 41.82%,
      rgba(160, 64, 224, 0.5) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    #081120;
  @media (max-width: 342px) {
    width: 290px;
  }
`;

export const InfoTitle = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.07px;
`;
export const InfoText = styled.span`
  color: #fff;
  font-family: Figtree;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.07px;

  opacity: 0.7;
`;

export const FadeWrapper = styled.div`
  position: relative;
  width: 100%;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 48px;
    background: linear-gradient(to right, transparent, rgb(11, 23, 39));
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: ${({ $faded }) => ($faded ? 1 : 0)};
  }
`;
export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 100px;
  border: 1px solid #345884;
  padding: 0px 6px;

  cursor: pointer;

  ${({ $animation }) =>
    $animation &&
    css`
      background: linear-gradient(
        90deg,
        #152a47 0px,
        #23406a 40px,
        #152a47 80px
      );
      background-size: 468px 100%;
      animation:
        ${shimmer} 3s infinite linear,
        ${pulse} 2s infinite ease-in-out;
    `}

  svg {
    path {
      stroke: #fff;
    }
  }
`;

export const FolderItem = styled.div`
  min-width: ${({ $width }) => $width && `${$width}px`};
  white-space: nowrap;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 100px;
  border: 1px solid #345884;

  display: flex;
  height: 32px;
  padding: 0px 6px;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  ${({ $animation }) =>
    $animation &&
    css`
      background: linear-gradient(
        90deg,
        #152a47 0px,
        #23406a 40px,
        #152a47 80px
      );
      background-size: 468px 100%;
      animation:
        ${shimmer} 3s infinite linear,
        ${pulse} 2s infinite ease-in-out;
    `}
`;

export const CategoryText = styled.p`
  color: ${({ $selected }) => ($selected ? "#fff" : "#fff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  /* line-height: 18px; */
  letter-spacing: -0.07px;
  white-space: nowrap;
`;
